import { render, staticRenderFns } from "./RelatedTopics.vue?vue&type=template&id=35862cff&scoped=true&"
import script from "./RelatedTopics.vue?vue&type=script&lang=ts&"
export * from "./RelatedTopics.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedTopics.vue?vue&type=style&index=0&id=35862cff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35862cff",
  null
  
)

/* custom blocks */
import block0 from "./RelatedTopics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports